export const staffMarket = {
  engineers: [
    {
      id: 1,
      name: "Guillaume 'The Brain' Rossi",
      skill: 95,
      cost: 2000000,
      salary: 500000,
      wearReduction: 0.7,
      riskFactor: 0.02,
    },
    {
      id: 2,
      name: 'Sarah Jenkins',
      skill: 65,
      cost: 800000,
      salary: 150000,
      wearReduction: 0.9,
      riskFactor: 0.05,
    },
    {
      id: 3,
      name: 'Newbie Nick',
      skill: 30,
      cost: 100000,
      salary: 40000,
      wearReduction: 1.1,
      riskFactor: 0.15,
    },
  ],
  pitCrews: [
    { id: 4, name: 'Elite Crew Alpha', skill: 98, cost: 1500000, pitTime: 2.1, failureChance: 0.01 },
    { id: 5, name: 'Standard Crew B', skill: 55, cost: 500000, pitTime: 3.2, failureChance: 0.08 },
    { id: 6, name: 'Local Mechanics', skill: 20, cost: 50000, pitTime: 5.5, failureChance: 0.25 },
  ],
};
